import React from "react";
import videojs from "video.js";
import "../../node_modules/video.js/dist/video-js.css";

export default class VideoPlayer extends React.Component {
  componentDidMount() {
    // instantiate Video.js
    this.player = videojs(
      this.videoNode,
      this.props,
      function onPlayerReady() {}
    );
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    if (this.props.recommendation) {
      return (
        <div style={{ height: this.props.windowHeight }}>
          <div
            data-vjs-player
            className="recommendation_full_page_video"
            style={{ height: this.props.windowHeight }}
          >
            <video
              key={this.props.recommendation.id}
              width="100%"
              height="100%"
              poster={this.props.recommendation.video_url_image}
              ref={node => (this.videoNode = node)}
              className="video-js vjs-default-skin vjs-big-play-centered recommendation_full_page_video content-fit"
              data-setup="{}"
              style={{ height: this.props.windowHeight }}
            />
          </div>
        </div>
      );
    }

    return (
      <div style={{ height: this.props.windowHeight }}>
        <div
          data-vjs-player
          className="recommendation_full_page_video"
          style={{ height: this.props.windowHeight }}
        >
          <video
            ref={node => (this.videoNode = node)}
            className="video-js vjs-default-skin vjs-big-play-centered recommendation_full_page_video video_create content-fit"
            data-setup="{}"
            style={{ height: this.props.windowHeight }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/video_player.jsx